import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-boxoffice-pos-status',
  templateUrl: './boxoffice-pos-status.component.html',
  styleUrls: ['./boxoffice-pos-status.component.scss']
})
export class BoxofficePosStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/boxoffice/boxoffice-pos-status/boxoffice-pos-status.component.ts